import {ElasticParser, ElasticSearchProperty} from '../factory.parsers';
import {buildQueryTermEqual} from '../../query/elastic.queries';
import {RegexParser} from './regex.parser';

export class MousParser implements ElasticParser {
  parseValue(mousString: string, elasticSearchProperty: ElasticSearchProperty): any {
    mousString = mousString?.trim();

    const {property} = elasticSearchProperty;
    const mousChunks = mousString?.split('_');

    if (mousChunks?.length === 6) {
      return buildQueryTermEqual(property, `uid://${mousChunks[3]}/${mousChunks[4]}/${mousChunks[5]}`);
    } else {
      const regexParser = new RegexParser();
      return regexParser.parseValue(mousString, elasticSearchProperty);
    }
  }
}
